import React from "react";

const FAQS = () => {
  return (
    <div>
      <h1 className="text-center" style={{ color: "#2f3778" }}>
        FAQS
      </h1>
    </div>
  );
};

export default FAQS;
